<template>
  <div class="bg-white pt-6 pt-12 lg:pt-12 pb-8 px-4 lg:px-20 relative footer">
    <img src="@/assets/logo.svg" alt="PaddyCover Logo">
    <div class="mt-12 lg:mt-6 lg:flex  lg:justify-between lg:items-center">
      <div>
        <router-link to="/faq" class="text-current text-current text-sm block mt-2 lg:inline lg:mr-6">FAQ</router-link>
        <a id="speak" href="tel:+2348100578550" class="text-current text-sm block mt-2 lg:inline lg:mr-6">
          Speak to Us Now
        </a>
        <router-link to="/about" class="text-current text-sm block mt-2 lg:inline lg:mr-6">About</router-link>
        <router-link to="/terms" class="text-current text-sm block mt-2 lg:inline lg:mr-6">Terms</router-link>
        <router-link to="/privacy" class="text-current text-sm block mt-2 lg:inline lg:mr-6">Privacy Policy</router-link>
      </div>
      <div class="mt-8 lg:mt-0 flex items-center">
        <a rel="noopener noreferrer" target="blank" href="https://www.facebook.com/PaddyCover-584299082020703" class="inline mr-3 lg:mr-6">
          <font-awesome-icon :icon="['fab', 'facebook']" class="text-army text-lg" />
        </a>
        <a rel="noopener noreferrer" target="blank" href=" https://twitter.com/PaddyCover?s=09" class="inline mr-3 lg:mr-6">
          <font-awesome-icon :icon="['fab', 'twitter']" class="text-army text-lg" />
        </a>
        <a rel="noopener noreferrer" target="blank" href="https://www.linkedin.com/company/paddycover/" class="inline mr-3 lg:mr-6">
          <font-awesome-icon :icon="['fab', 'linkedin']" class="text-army text-lg" />
        </a>
        <a rel="noopener noreferrer" target="blank" href="https://instagram.com/paddycover" class="inline mr-3 lg:mr-6">
          <svg class="inline text-white text-lg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.002 21.041C9.54195 21.041 9.25195 21.028 8.29195 20.986C7.54332 20.9614 6.80439 20.8092 6.10695 20.536C4.90026 20.0664 3.94609 19.1119 3.47695 17.905C3.21426 17.205 3.07257 16.4655 3.05795 15.718C3.00195 14.76 3.00195 14.446 3.00195 12.005C3.00195 9.538 3.01495 9.25 3.05795 8.295C3.07289 7.54853 3.21457 6.81001 3.47695 6.111C3.94558 4.90253 4.9013 3.94718 6.10995 3.479C6.8086 3.21521 7.5473 3.07315 8.29395 3.059C9.24895 3.005 9.56295 3.005 12.002 3.005C14.482 3.005 14.767 3.018 15.712 3.059C16.4605 3.07327 17.2012 3.21531 17.902 3.479C19.1103 3.94771 20.0658 4.90288 20.535 6.111C20.8021 6.8202 20.9445 7.57026 20.956 8.328C21.012 9.286 21.012 9.59901 21.012 12.039C21.012 14.479 20.998 14.799 20.956 15.746C20.9411 16.4942 20.799 17.2344 20.536 17.935C20.0656 19.1427 19.11 20.0976 17.902 20.567C17.2022 20.8292 16.4631 20.9709 15.716 20.986C14.761 21.041 14.448 21.041 12.002 21.041ZM11.968 4.588C9.52195 4.588 9.26795 4.6 8.31295 4.643C7.74294 4.65056 7.17843 4.75575 6.64395 4.954C5.85471 5.25601 5.23018 5.878 4.92495 6.666C4.72517 7.2063 4.61996 7.77698 4.61395 8.353C4.56095 9.322 4.56095 9.576 4.56095 12.005C4.56095 14.405 4.56995 14.696 4.61395 15.659C4.62291 16.2292 4.72805 16.7938 4.92495 17.329C5.23063 18.1165 5.85505 18.738 6.64395 19.04C7.17807 19.2396 7.7428 19.3448 8.31295 19.351C9.28095 19.407 9.53595 19.407 11.968 19.407C14.421 19.407 14.675 19.395 15.622 19.351C16.1924 19.3441 16.7573 19.2389 17.292 19.04C18.0764 18.7354 18.6969 18.1153 19.002 17.331C19.2014 16.7903 19.3065 16.2193 19.313 15.643H19.324C19.367 14.687 19.367 14.432 19.367 11.989C19.367 9.54601 19.356 9.289 19.313 8.334C19.304 7.76446 19.1988 7.20052 19.002 6.666C18.6976 5.88058 18.077 5.2593 17.292 4.954C16.7574 4.75475 16.1924 4.64953 15.622 4.643C14.655 4.588 14.402 4.588 11.968 4.588ZM12.002 16.624C10.1319 16.6252 8.44537 15.4997 7.72882 13.7725C7.01226 12.0452 7.40686 10.0563 8.72858 8.73347C10.0503 7.4106 12.0388 7.01428 13.7667 7.72934C15.4946 8.4444 16.6215 10.13 16.622 12C16.6192 14.5511 14.553 16.619 12.002 16.624ZM12.002 8.998C10.3451 8.998 9.00195 10.3412 9.00195 11.998C9.00195 13.6549 10.3451 14.998 12.002 14.998C13.6588 14.998 15.002 13.6549 15.002 11.998C14.9981 10.3427 13.6572 9.00185 12.002 8.998ZM16.802 8.28501C16.2074 8.2828 15.7269 7.79959 15.728 7.20501C15.7291 6.61043 16.2114 6.12901 16.806 6.12901C17.4005 6.12901 17.8828 6.61042 17.884 7.205C17.8842 7.49187 17.7702 7.76703 17.5672 7.96968C17.3642 8.17234 17.0888 8.2858 16.802 8.28501Z" fill="#219653"></path>
          </svg>
        </a>
      </div>
    </div>
    <hr class="w-full mt-6 lg:mt-12">
    <div class=" mt-6 flex flex-col gap-8 lg:flex-row lg:justify-between">
      <div>
        <p class="text-gray-500 text-xs">© 2021-2022 paddycover Ltd.</p>
      </div>
      <p class="text-gray-500 text-xs">PaddyCover is operated in partnership with NAICOM approved insurers.</p>
    </div>
  </div>
</template>

<script>
// import { watch } from 'vue';


export default {

// computed: {
//   isMobile() {
//   const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
//   return regex.test(navigator.userAgent);
// },

// check() {
//     if (isMobile()) {
//     console.log("Mobile device detected");
//   } else {
//     console.log("Desktop device detected");
//   }
// }

// },

mounted() {
  
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  // return regex.test(navigator.userAgent);
  if (regex.test(navigator.userAgent)) {
    let input = document.getElementById('speak');
    input.setAttribute('href', 'tel:+2349136000847')
    // console.log("Mobile device detected");
  } else {
    let input = document.getElementById('speak');
    input.setAttribute('href', 'mailto: info@paddycover.com')
    // console.log("Desktop device detected");
  }



// check() {
//     if (isMobile()) {
//     console.log("Mobile device detected");
//   } else {
//     console.log("Desktop device detected");
//   }
// }
}

}

</script>

<style scoped>

.rolls{
  top: -80px;
  height: 150px;
}
.rollsleft{
  left: -50px;
}
.rollsright{
  top: -70px;
  right: -50px;
}
@media only screen and (min-width: 1024px){
    .footer{
        padding-left: 10%;
        padding-right: 10%;
    }
}
</style>